export default {
      id: "mail-alt-usage",
      viewBox: "80 175 430 430",
      url: __webpack_public_path__ + "assets/icons/icon-sprite.svg#mail-alt-usage",
      toString: function () {
        return this.url;
      }
    }